<div class="login-page">
    <div class="login-shell login-shell-wide">
        <section class="login-intro">
            <div class="intro-visual" aria-hidden="true">
                <span class="orb orb-1"></span>
                <span class="orb orb-2"></span>
                <span class="orb orb-3"></span>
                <div class="intro-badge">
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <i class="fa fa-user-plus"></i>
                </div>
            </div>
            <div class="intro-copy">
                <h2>Create your account</h2>
                <p>Register to access Sovos products and manage your business identity across the platform.</p>
                <ul class="intro-points">
                    <li><i class="fa fa-users"></i><span>Single account across products</span></li>
                    <li><i class="fa fa-shield"></i><span>Enterprise-grade security</span></li>
                    <li><i class="fa fa-check-circle"></i><span>Consent-based data handling</span></li>
                </ul>
            </div>
        </section>

        <section class="login-panel">
            <div class="login-brand">
                <img src="assets/images/sovos-logo-dark.png" alt="Sovos">
            </div>
            <form [formGroup]="signupForm" class="login-form" autocomplete="off" (ngSubmit)="signup()">
                <h1 class="login-title">Sign up</h1>
                <p class="login-subtitle">Enter your details to create a new Sovos account.</p>

                <div class="login-field">
                    <label for="signupUsername">Username</label>
                    <input type="text" class="login-input" id="signupUsername" placeholder="Username"
                        formControlName="name" [ngClass]="{ 'errorBorder': isSubmitted && f.name.errors }"
                        autocomplete="username" autocorrect="off" autocapitalize="off" spellcheck="false">
                    <div *ngIf="isSubmitted && f.name.errors">
                        <span class="login-error" *ngIf="f.name.errors.required">Username Required</span>
                    </div>
                </div>

                <div class="login-field">
                    <label for="signupEmail">Email ID</label>
                    <input type="email" class="login-input" id="signupEmail" placeholder="Email ID"
                        formControlName="email" [ngClass]="{ 'errorBorder': isSubmitted && f.email.errors }"
                        autocomplete="email" autocorrect="off" autocapitalize="off" spellcheck="false">
                    <div *ngIf="isSubmitted && f.email.errors">
                        <span class="login-error" *ngIf="f.email.errors.required">Email Required</span>
                        <span class="login-error" *ngIf="f.email.errors && !f.email.errors.required">Invalid Email</span>
                    </div>
                </div>

                <div class="login-check">
                    <input type="checkbox" id="consentGiven" formControlName="consentGiven"
                        [ngClass]="{ 'errorBorder': isSubmitted && f.consentGiven.errors }">
                    <label for="consentGiven">
                        In compliance with the Information Technology Act 2000 and related rules, we seek your consent
                        to collect and use your personal data (e.g. email ID, mobile number) for authentication,
                        notifications, and service facilitation on our platform. By providing your personal data, you
                        agree to its collection, use, processing, and storage as per our
                        <a href="https://sovos.com/software-and-services-terms/" target="_blank">Terms &amp; Conditions</a>
                        and
                        <a href="https://sovos.com/software-and-services-terms/data-privacy/" target="_blank">Privacy Policy</a>.
                        Your data will not be disclosed without your explicit consent unless required by law.
                    </label>
                </div>
                <div *ngIf="isSubmitted && f.consentGiven.errors">
                    <span class="login-error" *ngIf="f.consentGiven.errors.required">Consent Required</span>
                </div>

                <re-captcha #invisible (resolved)="resolved($event)" size="invisible" [siteKey]="recaptchaSiteKey"></re-captcha>

                <button type="submit" class="login-btn login-btn-primary login-btn-submit" [disabled]="isDisabled">SIGN UP</button>

                <div class="login-links login-links-split">
                    <a (click)="forgotPassword()">Forgot password?</a>
                    <a (click)="login()">Sign in</a>
                </div>

                <div class="login-note">
                    Sovos Compliance Private Limited, Mindspace Airoli East, Building number 3, Floor 7, Airoli, Navi
                    Mumbai, Maharashtra 400708 |
                    <a href="https://www.sovos.com" target="_blank">https://www.sovos.com</a>
                </div>
            </form>
        </section>
    </div>
</div>
